/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EUserTypeSP = 'Admin' | 'ServiceProvider' | 'RepairShop' | 'Repairer';

export const EUserTypeSP = {
    Admin: 'Admin' as EUserTypeSP,
    ServiceProvider: 'ServiceProvider' as EUserTypeSP,
    RepairShop: 'RepairShop' as EUserTypeSP,
    Repairer: 'Repairer' as EUserTypeSP
};

